import axios from "axios";
import Cookies from "js-cookie";
import authConfig from "../config/auth";

const accessToken = Cookies.get(authConfig.ACCESS_TOKEN_COOKIE);
const apiUrl = process.env.VUE_APP_VIDEO_API_URL;

async function postFormData(endpoint, fields) {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => formData.append(key, value));

  return await axios({
    method: "post",
    url: apiUrl + endpoint,
    data: formData,
    headers: {
      "content-type": `multipart/form-data; boundary=${formData._boundary}`,
      Authorization: "Bearer " + accessToken
    }
  });
}

export default {
  async uploadSlideFile(data) {
    return await postFormData("slides", {
      comId: data.companyId,
      cId: data.courseId,
      lecId: data.lectureId,
      material: data.slideFile,
      accessToken: localStorage.getItem("token")
    });
  },

  async uploadCourseThumbnail(data) {
    return await postFormData("courses", {
      cId: data.courseId,
      comId: data.companyId,
      image: data.imageFile,
      accessToken: localStorage.getItem("token")
    });
  },

  async uploadCourseMaterial(data) {
    return await postFormData("materials", {
      material: data.file,
      name: data.file.name,
      description: "No description",
      status: "PUBLISH",
      cId: data.courseId,
      courseMaterialOrder: data.courseMaterialOrder
    });
  },

  async uploadProfileImage(data) {
    return await postFormData("members", {
      mId: data.memberId,
      comId: data.comId,
      image: data.imageFile,
      accessToken: localStorage.getItem("token")
    });
  },

  async uploadBookCover(data) {
    return await postFormData("books", {
      com_id: data.companyId,
      image: data.imageFile,
      accessToken: localStorage.getItem("token")
    });
  }
};
